<template>
    <div class="style-form pt-5 pb-4 px-3 p-md-5">
        <div class="col-12 pb-5">
            <h5 class="font-weight-bold">Envianos un mensaje</h5>
        </div>
        <div class="col-12">
            <form
                id="form-contactanos"
                class="row"
                @submit.prevent="sendMessage"
                method="POST"
            >
                <input type="hidden" name="_token" :value="csrf" />
                <div class="col-12 form-group">
                    <input
                        type="text"
                        placeholder="Nombre"
                        v-model.trim="$v.form.nombre.$model"
                        name="nombre"
                        :class="
                            !$v.form.nombre.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    />
                    <div class="error-data" v-if="$v.form.nombre.$dirty">
                        <span v-if="!$v.form.nombre.required"
                            >Campo necesario</span
                        >
                    </div>
                </div>
                <div class="col-12 col-md-6 form-group">
                    <input
                        type="text"
                        placeholder="Email"
                        v-model.trim="$v.form.email.$model"
                        name="email"
                        :class="
                            !$v.form.email.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    />
                    <div class="error-data" v-if="$v.form.email.$dirty">
                        <span v-if="!$v.form.email.required"
                            >Campo necesario</span
                        >
                        <span v-if="!$v.form.email.email">Email inválido</span>
                    </div>
                </div>
                <div class="col-12 col-md-6 form-group">
                    <input
                        type="text"
                        placeholder="RUT"
                        name="rut"
                        v-rut:live
                        v-model.trim="$v.form.rut.$model"
                        :class="
                            !$v.form.rut.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    />
                    <div class="error-data" v-if="$v.form.rut.$dirty">
                        <span
                            v-if="
                                !$v.form.rut.rutValidation ||
                                !$v.form.rut.minLength
                            "
                            >RUT Inválido</span
                        >
                    </div>
                </div>
                <div class="col-12 form-group">
                    <input
                        type="text"
                        placeholder="Teléfono"
                        @keypress="onlyNumber"
                        v-model.trim="$v.form.telefono.$model"
                        maxlength="9"
                        name="telefono"
                        :class="
                            !$v.form.telefono.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    />
                    <div class="error-data" v-if="$v.form.telefono.$dirty">
                        <span v-if="!$v.form.telefono.required"
                            >Campo necesario</span
                        >
                        <span v-if="!$v.form.telefono.minLength"
                            >Teléfono inválido</span
                        >
                        <span v-if="!$v.form.telefono.maxLength"
                            >Teléfono inválido</span
                        >
                    </div>
                </div>
                <div class="col-12 form-group">
                    <textarea
                        cols="30"
                        rows="6"
                        placeholder="Mensaje"
                        v-model.trim="$v.form.mensaje.$model"
                        name="mensaje"
                        :class="
                            !$v.form.mensaje.$anyError
                                ? 'form-control w-100'
                                : 'form-control w-100 form-error'
                        "
                    >
                    </textarea>
                    <div class="error-data" v-if="$v.form.mensaje.$dirty">
                        <span v-if="!$v.form.mensaje.required"
                            >Campo necesario</span
                        >
                    </div>
                </div>
                <div class="col-12 col-md-5 ml-auto mt-5">
                    <button
                        :disabled="formLoading || $v.form.$invalid"
                        type="submit"
                        class="btn bg-main-color text-white btn-block"
                    >
                        {{ btnText }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { required, minLength, email, maxLength } from 'vuelidate/lib/validators'
import { rutValidator, rutInputDirective } from 'vue-dni'

import Vue from 'vue'
Vue.directive('rut', rutInputDirective)

export default {
    name: 'forContactanos',
    data: () => ({
        csrf: document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content'),
        formLoading: false,
        btnText: 'Enviar',
        form: {
            nombre: '',
            rut: '',
            email: '',
            telefono: '',
            mensaje: ''
        }
    }),
    methods: {
        sendMessage () {
            this.$v.form.$touch()
            if (!this.$v.form.$invalid) {
                this.btnText = 'Enviando...'
                this.formLoading = true
                const ruta = 'contacto-formulario'
                $('#form-contactanos').attr('action', ruta).submit()
            }
        },
        onlyNumber ($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                // 46 is dot
                $event.preventDefault()
            }
        }
    },
    validations: {
        form: {
            nombre: {
                required
            },
            rut: {
                required,
                rutValidation: rutValidator,
                minLength: minLength(9)
            },
            email: {
                required,
                email
            },
            telefono: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(9)
            },
            mensaje: {
                required
            }
        }
    }
}
</script>

<style scoped>
.style-form {
    background-color: #fff;
}

.icon-style {
    font-size: 3rem !important;
}

.color-text-default {
    color: #707070;
}
</style>
